import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EventsFiltersState } from './events.state';
import { INITIAL_EVENT_FILTERS } from '../../declarations/article.interface';
import { getDefaultFeedOrigin } from '../tenant-state/tenant.selectors';

const getFeatureState =
  createFeatureSelector<EventsFiltersState>('eventsFilterState');

export const getCurrentEventsFilters = createSelector(
  getFeatureState,
  (state: EventsFiltersState) => state?.currentEventsFilters
);

export const isEventsFilterActive = createSelector(
  getFeatureState,
  getDefaultFeedOrigin,
  (
    state: EventsFiltersState,
    initialOrigin: 'my_settlement' | 'all'
  ): boolean => {
    const filters = state.currentEventsFilters;

    return !!(
      filters.period != INITIAL_EVENT_FILTERS.period ||
      filters.memberOnly != INITIAL_EVENT_FILTERS.memberOnly ||
      (filters.groupIds && filters.groupIds.length > 0) ||
      (filters.origin && filters.origin !== initialOrigin) ||
      filters.periodStart ||
      filters.periodEnd
    );
  }
);
